import { Box, Stack, Typography, Tabs, Tab } from "@mui/material";
import { Link } from "react-router-dom";
import { Loader } from "src/shared/components";
import { usePartnerTabs } from "../../model/helpers";

interface IPartnerPageWrapperProps {
  partnerId: string;
  isLoading: boolean;
  partnerName: string;
  children?: React.ReactNode;
  tabValue?: number | string;
}
export function PartnerPageWrapper({
  partnerId,
  isLoading,
  partnerName,
  children,
  tabValue: rawTabValue,
}: IPartnerPageWrapperProps) {
  const getTabValueFromPath = (path: string) => {
    if (path.includes("/contracts/")) {
      return "/crm/partners/1/contracts"; // Базовый путь вкладки "Договоры"
    }

    return path;
  };

  const tabValue = getTabValueFromPath(rawTabValue as string); // преобразуем в допустимое значение
  const partnerTabs = usePartnerTabs({ partnerId });

  return (
    <Box
      sx={{
        position: "relative",
        py: 4,
        height: "100%",
      }}
    >
      {isLoading && <Loader position="absolute" />}
      <Stack spacing={6} height="100%">
        <Typography
          variant="h4"
          component="h1"
          sx={{ overflowWrap: "anywhere", wordBreak: "break-word" }}
        >
          {partnerName}
        </Typography>
        <Tabs value={tabValue}>
          {partnerTabs.map(({ label, to }) => (
            <Tab
              key={to}
              to={to}
              value={to}
              component={Link}
              label={label}
              sx={{
                "&.Mui-selected": {
                  color: "grey.900",
                },
              }}
            />
          ))}
        </Tabs>
        <Box sx={{ flex: 1, minHeight: 0 }}>{children}</Box>
      </Stack>
    </Box>
  );
}
